import Button, { ButtonProps } from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";

interface FdButtonProps extends ButtonProps {
	onlyIcon?: boolean;
	disabled?: boolean;
	arrowDisabled?: boolean;
    ButtonName?:string;
    isLoading?:boolean;
	Icon?:any;
}

const FdButton = ({
	disabled,
    variant = "contained",
    size,
    ButtonName,
	isLoading,
	startIcon,
	endIcon,
	Icon,
	children,
	...others
}: FdButtonProps): JSX.Element => {
  return (
      <Button variant={variant} size={size} disabled={disabled} {...others} startIcon={!isLoading&& startIcon} endIcon={!isLoading&& endIcon}>
		{isLoading ? <CircularProgress size={20} /> : ButtonName || Icon} {children}
		</Button>
  );
};

export default FdButton;
